module.exports = __webpack_public_path__ + "img/Tom Greupner.afde62bc.jpg";